import React from "react";
import ZoomEditor from "./ZoomEditor";

const Editors = () => {
    return (
        <>
            <ZoomEditor />
        </>
    );
};
export default Editors;
